import {CrmType as CrmTypes} from 'src/openapi/admin/models/CrmType';
import {DateFormat} from 'src/openapi/admin/models/DateFormat';
import {DecimalFormat} from 'src/openapi/admin/models/DecimalFormat';
import {EmailType} from 'src/openapi/admin/models/EmailType';
import {PaperFormat} from 'src/openapi/admin/models/PaperFormat';
import {SupportedCurrency} from 'src/openapi/admin/models/SupportedCurrency';
import {SymbolPosition} from 'src/openapi/admin/models/SymbolPosition';
import {ThousandFormat} from 'src/openapi/admin/models/ThousandFormat';

export const MCP_TOOL_CALL_LIMIT_CODES = new Set(['MCP_PREM_M', 'MCP_CORP_M']);

export const UPLOAD_USERS_LIST_TEMPLATE = '/static/Upload-users-list.template.csv';
export const UPLOAD_ACCOUNTS_LIST_TEMPLATE = '/static/Upload-accounts-list.template.csv';

export const HEADER_HEIGHT = 48;
export const SEARCH_RESULT_HEADER_HEIGHT = 86;
export const MAX_SELECTED_ACCOUNTS = 500;
export const MAX_SELECTED_ENTITIES = 5000;
export const MAX_NUMBER_VALUE = 2147483647;

export const MAX_ENTITIES_MESSAGE = `${MAX_SELECTED_ENTITIES} - maximum number of selected items.`;
export const UNCLEAR_QUERY_MESSAGE = 'The search query is less than the minimum allowed, continue typing...';

export const ACCOUNT_TABS = {
    PROFILE: {
        name: 'account-profile',
        caption: 'Account Profile',
    },
    DETAILS: {
        name: 'details',
        caption: 'Account Details',
    },
    USERS: {
        name: 'users-groups',
        caption: 'Users & Groups',
    },
    LICENSE: {
        name: 'license-features',
        caption: 'License & Features',
    },
    PRODUCT_ACCESS: {
        name: 'product-access',
        caption: 'Product Access',
    },
    API: {
        name: 'api',
        caption: 'API',
    },
    MCP: {
        name: 'mcp',
        caption: 'DD MCP',
    },
    SETTINGS: {
        name: 'settings',
        caption: 'Settings',
    },
    AUDIT_LOG: {
        name: 'audit-log',
        caption: 'Audit Log',
    },
    ENTITLEMENTS: {
        name: 'entitlements',
        caption: 'Entitlements',
    },
    CONFERENCE: {
        name: 'conference',
        caption: 'Conference',
    },
    MICRO_SITES: {
        name: 'micro-sites',
        caption: 'Microsites',
    },
    ASSIGN_ENTITLEMENTS: {
        name: 'assign-resources',
        caption: 'Assign Entitlements',
    },
    CREATE_LICENSE: {
        name: 'create-license',
        caption: 'Create License',
    },
    CREATE_USER: {
        name: 'create-user',
        caption: 'Create User',
    },
    ASSIGN_USERS_ENTITLEMENTS: {
        name: 'assign-users-entitlements',
        caption: 'Assign Users Entitlements',
    },
    DISCHARGE_USERS_ENTITLEMENTS: {
        name: 'discharge-users-entitlements',
        caption: 'Discharge Users Entitlements',
    },
};

export const USER_TABS = {
    DETAILS: {
        name: 'user-details',
        caption: 'User Details',
    },
    SETTINGS: {
        name: 'settings',
        caption: 'Settings',
    },
    LOGIN: {
        name: 'login',
        caption: 'Login & Password',
    },
    PRODUCTS: {
        name: 'products',
        caption: 'Products',
    },
    LIMITS: {
        name: 'limits',
        caption: 'Limits',
    },
    ENTITLEMENTS: {
        name: 'entitlements',
        caption: 'Entitlements',
    },
    PERSONALIZATION: {
        name: 'personalization',
        caption: 'Personalization',
    },
    CONFERENCES: {
        name: 'conferences',
        caption: 'Conferences',
    },
    CONTENT: {
        name: 'content',
        caption: 'Content',
    },
    ASSIGNED_ACCOUNTS: {
        name: 'assigned-accounts',
        caption: 'Assigned Accounts',
    },
    ROLE_SETTINGS: {
        name: 'role-settings',
        caption: 'Role Settings',
    },
    ACTIVITY_LOG: {
        name: 'reports',
        caption: 'Reports',
    },
    AUDIT_LOG: {
        name: 'audit-log',
        caption: 'Audit Log',
    },
    ASSIGN_ENTITLEMENTS: {
        name: 'assign-resources',
        caption: 'Assign Resources',
    },
};

export const SEARCH_RESULT_TABS = {
    ACCOUNTS: 'accounts',
    USERS: 'users',
};

export const ROUTES = {
    CREATE_ROLE: '/roles/create',
    PROFILE: '/roles',
};

export const FUTURE_FEATURE_MESSAGE = 'The feature is coming soon';
export const STACKOVERFLOW_MESSAGE = 'Please try again once current action finishes';
export const DOWNLOAD_STACKOVERFLOW_MESSAGE = 'Only one report can be downloaded at once. Please wait';
export const DOWNLOAD_REQUEST_MESSAGE = 'The file is being generated';
export const DOWNLOAD_SUCCESS_MESSAGE = 'The file has been downloaded successfully';
export const DOWNLOAD_FAILED_MESSAGE = 'The file has not been downloaded. Please, try again.';

export const NO_RESULTS_MESSAGE = 'Sorry, your search has no results for the specified criteria';

export const AUTO_CLOSE_SUCCESS_MS = 2500;
export const AUTO_CLOSE_INFO_MS = 3000;
export const AUTO_CLOSE_ERROR_MS = 5000;

export const SAVE_CHANGES_SUCCESS_MESSAGE = 'Your changes have been saved.';
export const DISCARD_CHANGES_SUCCESS_MESSAGE = 'Your changes have been discarded and reset to last saved settings.';

export const DEFAULT_LOCALE = {
    currency: SupportedCurrency.USD,
    dateFormat: DateFormat.MMDDYYYY,
    decimalFormat: DecimalFormat.COMMA,
    paperFormat: PaperFormat.A4,
    symbolPosition: SymbolPosition.LEFT,
    thousandFormat: ThousandFormat.COMMA,
    nativeCurrencyHover: false,
    isCustomSettings: false,
};

export const CRM_NAMES = {
    [CrmTypes.SFCRM]: 'Salesforce',
    [CrmTypes.MDCRM]: 'MS Dynamics',
    [CrmTypes.DEALCLOUDCRM]: 'DealCloud',
    [CrmTypes.HUBSPOTCRM]: 'HubSpot',
    [CrmTypes.PITCHBOOK]: 'PitchBook',
};


export enum UserSearchStateCriteria {
    LICENSED = 'LICENSED',
    MOBILE = 'MOBILE',
    CRM_ONLY = 'CRM_ONLY',
    FREE_NEWSLETTER = 'FREE_NEWSLETTER',
    NO_ACCESS = 'NO_ACCESS',
    CREDIT_ALERTS_ONLY = 'CREDIT_ALERTS_ONLY',
}

export const USER_STATES: {[key: string]: UserSearchStateCriteria} = {
    'licensed': UserSearchStateCriteria.LICENSED,
    'mobile': UserSearchStateCriteria.MOBILE,
    'crm-only': UserSearchStateCriteria.CRM_ONLY,
    'disabled': UserSearchStateCriteria.FREE_NEWSLETTER,
    'no-access': UserSearchStateCriteria.NO_ACCESS,
    'credit-alerts-only': UserSearchStateCriteria.CREDIT_ALERTS_ONLY,
};

export const CONTRACT_ID_EXPLANATION = 'Contract ID in the Salesforce environment';


export const NO_AM_ERROR =
`The Welcome Email could not be sent.
Please make sure the account the user belongs to has proper account team members assigned.
The account should have at least one Account Manager assigned.`;

export const FORBIDDEN_FOR_MANDATORY_SSO_ERROR =
`The Welcome Email could not be sent.
This email contains a link to the Password Reset Page and therefore cannot be used for users
who are required to log in exclusively through SSO.`;

export const ONLY_SSO_LOGIN_FLOW_ERROR =
`The Welcome Email could not be sent.
This email is only available to users who log in via SSO
and is not accessible to users who log in with a password.`;

export const INACTIVE_OR_DISABLED_LOGIN_ERROR =
`The Welcome Email could not be sent.
This email cannot be sent to users who are either inactive or unable to log in to the system.
Please make sure the user is active and has valid login access before attempting to send the email.`;

export const FORBIDDEN_FOR_TRIAL_ERROR =
`The Welcome Email could not be sent.
This email is only available to users of an account with the Entity Type 'Trial'.`;

type EmailSettings = {
    key: string,
    amCsmRequired: boolean,
    // Account team members are optional: the email falls back to Support contacts when none are selected
    supportFallback?: boolean,
    value: EmailType,
    label: string,
    // Shown in the tooltip next to the radio button and, unless confirmMessage is set, in the confirmation dialog
    infoPopover: string,
    confirmMessage?: string,
    // Replaces confirmMessage when the account has no AM/CSM assigned
    noTeamConfirmMessage?: string,
    ssoEnabled: boolean,
    ssoMandatory: boolean,
};

export const EMAIL_SETTINGS: Record<EmailType, EmailSettings> = {
    [EmailType.WELCOME_EMAIL]: {
        key: 'welcomeEmail',
        amCsmRequired: false,
        value: EmailType.WELCOME_EMAIL,
        label: 'Welcome Email',
        infoPopover:
            `A welcome email will be sent to this user containing a login link.
When the user clicks on this link, they will be taken to the
Password Reset Page and must create a new password.
No AM/CSM contact information will be present on this email.

Note: Login Links are one-time use only and expire after 24 hours.`,
        ssoEnabled: false,
        ssoMandatory: false,
    },
    [EmailType.AM_WELCOME_EMAIL]: {
        key: 'am/csmWelcomeEmail',
        amCsmRequired: true,
        value: EmailType.AM_WELCOME_EMAIL,
        label: 'AM/CSM Welcome Email',
        infoPopover:
            `A welcome email will be sent to this user containing a login link.
When the user clicks on this link, they will be taken to the
Password Reset Page and must create a new password.

This email will contain contact information for the AM and CSM
assigned to this account.

Note: Login Links are one-time use only and expire after 24 hours.`,
        ssoEnabled: false,
        ssoMandatory: false,
    },
    [EmailType.AM_WELCOME_EMAIL_NO_GIFT]: {
        key: 'am/csmNoGiftWelcomeEmail',
        amCsmRequired: true,
        value: EmailType.AM_WELCOME_EMAIL_NO_GIFT,
        label: 'AM/CSM Welcome Email No Gift',
        infoPopover:
            `A welcome email will be sent to this user containing a login link.
When the user clicks on this link, they will be taken to the
Password Reset Page and must create a new password.

This email DOES contain the PitchBook Pioneer Course link but will
NOT trigger a gift to be sent to the user once complete.

Note: Login Links are one-time use only and expire after 24 hours.`,
        ssoEnabled: false,
        ssoMandatory: false,
    },
    [EmailType.AM_WELCOME_EMAIL_SSO_NO_GIFT]: {
        key: 'am/csmNoGiftSsoWelcomeEmail',
        amCsmRequired: true,
        value: EmailType.AM_WELCOME_EMAIL_SSO_NO_GIFT,
        label: 'AM/CSM Welcome Email SSO No Gift',
        infoPopover:
            `A welcome email will be sent to this user containing a login link.
When the user clicks on this link, they will be taken to SSO login
page for user to enter their email and log in.

This email DOES contain the PitchBook Pioneer Course link but will
NOT trigger a gift to be sent to the user once complete.`,
        ssoEnabled: false,
        ssoMandatory: true,
    },
    [EmailType.AM_WELCOME_EMAIL_SSO]: {
        key: 'am/csmSsoWelcomeEmail',
        amCsmRequired: true,
        value: EmailType.AM_WELCOME_EMAIL_SSO,
        label: 'AM/CSM Welcome Email SSO',
        infoPopover:
            `A welcome email will be sent to this user containing a login link.
When the user clicks on this link, they will be taken to SSO login
page for user to enter their email and log in.`,
        ssoEnabled: false,
        ssoMandatory: true,
    },
    [EmailType.AM_WELCOME_EMAIL_TRIAL]: {
        key: 'am/csmTrialWelcomeEmail',
        amCsmRequired: true,
        value: EmailType.AM_WELCOME_EMAIL_TRIAL,
        label: 'AM/CSM Welcome Email Trial',
        infoPopover:
            `A welcome email will be sent to this user containing a login link.
When the user clicks on this link, they will be taken to the
Password Reset Page and must create a new password.

Note: Login Links are one-time use only and expire after 24 hours.`,
        ssoEnabled: false,
        ssoMandatory: false,
    },
    [EmailType.SMB_WELCOME_EMAIL]: {
        key: 'smbWelcomeEmail',
        amCsmRequired: false,
        value: EmailType.SMB_WELCOME_EMAIL,
        label: 'SMB Welcome Email',
        infoPopover:
            `This welcome email introduces Support first, then the assigned Account Manager.

A login link is in this email that takes the user
to the Password Reset Page and the user must create a new
password to gain access to the platform.

Note: Login Links are one-time use only and expire after 24 hours.`,
        ssoEnabled: false,
        ssoMandatory: false,
    },
    [EmailType.STARTUP_WELCOME_EMAIL]: {
        key: 'startupWelcomeEmail',
        amCsmRequired: false,
        value: EmailType.STARTUP_WELCOME_EMAIL,
        label: 'Startup Welcome Email',
        infoPopover:
            `This welcome email introduces Support only.

No AM or CSM contact information will be included in this welcome
email. A login link is in this email that takes the user
to the Password Reset Page and the user must create a new
password to gain access to the platform.

Note: Login Links are one-time use only and expire after 24 hours.`,
        ssoEnabled: false,
        ssoMandatory: false,
    },
    [EmailType.NEW_CLIENT_WELCOME_EMAIL]: {
        key: 'newClientWelcomeEmail',
        amCsmRequired: false,
        value: EmailType.NEW_CLIENT_WELCOME_EMAIL,
        label: 'New Client Welcome Email',
        infoPopover:
            `A welcome email will be sent to this user containing a login link.
When the user clicks on this link, they will be taken to the
Password Reset Page and must create a new password.
No AM/CSM contact information will be present on this email.
The Pioneer link and welcome gift details will be added.

Note: Login Links are one-time use only and expire after 24 hours.`,
        ssoEnabled: false,
        ssoMandatory: false,
    },
    [EmailType.ORIGIN_WELCOME_EMAIL]: {
        key: 'originWelcomeEmail',
        amCsmRequired: false,
        value: EmailType.ORIGIN_WELCOME_EMAIL,
        label: 'PitchBook Origin Welcome Email',
        infoPopover: 'These are for customers who have access to the Origin module only',
        confirmMessage:
            `A welcome email will be sent to this user containing a login link for PitchBook Origin.
New PitchBook users will be taken to the Password Reset Page and must create a new password
(users of accounts with SSO enabled receive an SSO login link instead).
Existing PitchBook users will be taken straight to the PitchBook Origin login page.
Contact information of the AM and Primary CSM assigned to the account will be present on this email.
If none are assigned, general Support contact details will be shown instead.
The AM and Primary CSM will also receive an internal notification about the client's Origin access.

Note: Login Links are one-time use only and expire after 24 hours.`,
        ssoEnabled: false,
        ssoMandatory: false,
    },
    [EmailType.LLM_ONLY_WELCOME_EMAIL]: {
        key: 'llmOnlyWelcomeEmail',
        amCsmRequired: false,
        supportFallback: true,
        value: EmailType.LLM_ONLY_WELCOME_EMAIL,
        label: 'LLM Only Welcome Email',
        infoPopover:
            `The user will receive a welcome email with a login link.
The link directs them to the SSO login page to sign in with their email.
The email also includes the default Highspot Resource Center link.`,
        confirmMessage:
            `A welcome email will be sent to this user containing a login link.
The link directs them to the SSO login page to sign in with their email.
The email also includes the default Highspot Resource Center link.
Contact information of the selected account team members will be present on this email.`,
        noTeamConfirmMessage:
            `A welcome email will be sent to this user containing a login link.
The link directs them to the SSO login page to sign in with their email.
The email also includes the default Highspot Resource Center link.
No AM/CSM is assigned to this account, so the PitchBook Support contact email
(support@pitchbook.com) will be present on this email instead.`,
        ssoEnabled: false,
        ssoMandatory: false,
    },
};
